module.exports = __webpack_public_path__ + "static/media/commentArtboard 1@0.5x.29a1fdc7.png";